import gql from "graphql-tag";

export const USER_MEDICAL_CONDITION_MUTATION = gql`
  mutation upsertUserMedicalCondition($medicalConditions: [String]!, $otherCondition: String) {
    upsertUserMedicalCondition(medicalConditions: $medicalConditions, otherCondition: $otherCondition) {
      success
      error
    }
  }
`;